import KeyValueItemBase from './KeyValueItemBase';
export type { KeyValueItemBaseProps } from './KeyValueItemBase';

export default KeyValueItemBase;
